export enum DashboardWidgetType {
  StatisticsCard = 1,
  GridView = 2,
  Chart = 3,
  RecentItemsList = 4,
  QuickActions = 5,
  Map = 6
}
